import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";

import ProductServices from "../../../services/ProductServices";
import SupplierServices from "../../../services/PoServices";
import RateChartServices from "../../../services/RateChartServices";

const RateChartModal = ({ show, handleClose, onSuccess }) => {

    const [loading, setLoading] = useState(false);

    const [productOptions, setProductOptions] = useState([]);
    const [supplierOptions, setSupplierOptions] = useState([]);

    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedSupplier, setSelectedSupplier] = useState(null);

    const [rate, setRate] = useState("");
    const [remarks, setRemarks] = useState("");

    useEffect(() => {

        if (show) {
            loadDropdowns();
        }

    }, [show]);

    const loadDropdowns = async () => {

        try {

            const [productRes, supplierRes] = await Promise.all([
                ProductServices.getAllProduct(),
                SupplierServices.activeSuppliers()
            ]);

            const products = productRes?.data?.data || [];

            const suppliers = supplierRes?.data || [];

            setProductOptions(
                products.map(item => ({
                    value: item._id,
                    label: `${item.partNo} | ${item.description}`,
                    description: item.description,
                    unit: item.unit?.name || "",
                    partNo: item.partNo
                }))
            );

            setSupplierOptions(
                suppliers.map(item => ({
                    value: item._id,
                    label: `${item.name} - ${item.address.state || "NA"}`,
                    name: item.name,
                    state: item.state
                }))
            );

        } catch (err) {
            console.error(err);
        }

    };

    const resetForm = () => {

        setSelectedProduct(null);
        setSelectedSupplier(null);
        setRate("");
        setRemarks("");

    };
    const handleModalClose = () => {

        resetForm();

        handleClose();

    };

    const handleSave = async () => {

        if (!selectedProduct) {
            return Swal.fire(
                "Validation",
                "Please select Part Number",
                "warning"
            );
        }

        if (!selectedSupplier) {
            return Swal.fire(
                "Validation",
                "Please select Supplier",
                "warning"
            );
        }

        if (!rate) {
            return Swal.fire(
                "Validation",
                "Please enter Rate",
                "warning"
            );
        }

        try {

            setLoading(true);

            await RateChartServices.createRateChart({

                masterItem: selectedProduct.value,

                supplier: selectedSupplier.value,

                rate,

                remarks,

                mode: "Manual"

            });

            await Swal.fire(
                "Success",
                "Rate Chart created successfully",
                "success"
            );

            // Refresh Parent List
            if (onSuccess) {
                await onSuccess();
            }

            // Reset Form & Close Modal
            handleModalClose();

        } catch (err) {

            Swal.fire(
                "Error",
                err?.response?.data?.message || "Something went wrong",
                "error"
            );

        } finally {

            setLoading(false);

        }

    };

    return (

        <Modal
            show={show}
            onHide={handleModalClose}
            size="lg"
            backdrop="static"
            centered
        >

            <Modal.Header closeButton>

                <Modal.Title>

                    Add Rate Chart

                </Modal.Title>

            </Modal.Header>

            <Modal.Body>

                <div className="row">

                    <div className="col-md-12 mb-3">

                        <label className="form-label">

                            Part Number <span className="text-danger">*</span>

                        </label>

                        <Select

                            options={productOptions}

                            value={selectedProduct}

                            onChange={setSelectedProduct}

                            placeholder="Select Part Number"

                        />

                    </div>
                    <div className="col-md-6 mb-3">

                        <label className="form-label">
                            Description
                        </label>

                        <input
                            type="text"
                            className="form-control"
                            value={selectedProduct?.description || ""}
                            readOnly
                        />

                    </div>
                    <div className="col-md-6 mb-3">

                        <label className="form-label">
                            Inventory-Unit
                        </label>

                        <input
                            type="text"
                            className="form-control"
                            value={selectedProduct?.unit || ""}
                            readOnly
                        />

                    </div>

                    <div className="col-md-12 mb-3">

                        <label className="form-label">

                            Supplier <span className="text-danger">*</span>

                        </label>

                        <Select

                            options={supplierOptions}

                            value={selectedSupplier}

                            onChange={setSelectedSupplier}

                            placeholder="Select Supplier"

                        />

                    </div>

                    <div className="col-md-12 mb-3">

                        <label className="form-label">

                            Rate <span className="text-danger">*</span>

                        </label>

                        <input
                            type="number"
                            className="form-control"
                            value={rate}
                            onChange={(e) => setRate(e.target.value)}
                            onWheel={(e) => e.target.blur()}
                        />

                    </div>

                    <div className="col-md-12">

                        <label className="form-label">

                            Remarks

                        </label>

                        <textarea

                            rows={3}

                            className="form-control"

                            value={remarks}

                            onChange={(e) => setRemarks(e.target.value)}

                        />

                    </div>

                </div>

            </Modal.Body>

            <Modal.Footer>

                <Button
                    variant="secondary"
                    onClick={handleModalClose}
                >
                    Close
                </Button>

                <Button
                    variant="primary"
                    onClick={handleSave}
                    disabled={loading}
                >
                    {loading ? "Saving..." : "Save"}
                </Button>

            </Modal.Footer>

        </Modal>

    );

};

export default RateChartModal;